import VisaModal from '@/models/Visa';

const GET_VISA_MATERIAL_LIST = 'GET_VISA_MATERIAL_LIST';

/**
 * 获取签证材料清单
 */
async function getVisaMaterialList(tradeCode) {
  const payload = await new VisaModal().materialListByTradeCode(tradeCode);
  return {
    type: GET_VISA_MATERIAL_LIST,
    payload
  }
}

const ACTION_TYPES = {
  GET_VISA_MATERIAL_LIST,
};

const ACTION = {
  getVisaMaterialList,
};

const VisaMaterialList = {
  ACTION_TYPES,
  ACTION
}

export default VisaMaterialList;